import { useTranslations } from "use-intl";
import {
  SelectInput,
  SelectInputProps,
} from "@/lib/Components/Form/Inputs/SelectInput";
import { ProDriverTowVehicleType } from "@/gql/graphql";

export function TowVehicleTypeInput(
  props: Omit<SelectInputProps<any>, "options">,
) {
  const t = useTranslations("proDriver");

  return (
    <SelectInput
      options={[
        {
          label: t("towVehicle.type"),
          options: Object.values(ProDriverTowVehicleType).map((type) => ({
            label: t(`towVehicleType.${type}`),
            value: type,
          })),
        },
      ]}
      {...props}
    />
  );
}
